<template>
<div>
  <div class="section-header">
    <div>Running Assessments</div>
    <router-link :to="{name: 'coachAssessmentLibrary'}" color="primary" flat>Create An Assessment</router-link>
  </div>
  <div class="card card--white">
    <div class="card card--container">
      <div class="section" v-for="assessment in coachCreatedAssessment" :key="assessment.id">
        <div class="row align-center space-between">
          <h3>{{assessment.assessment.name}}</h3>
          <v-menu bottom left>
            <button icon slot="activator">
              <h-icon>more_vert</h-icon>
            </button>
            <v-list>
              <v-list-tile @click="displayModal(assessment)">
                <v-list-tile-title>
                  Edit
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="destroy(assessment)">
                <v-list-tile-title>Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>

        Link: <a :href="assessment.link">{{assessment.link}}</a>
        <div>{{assessment.assessment.description}}</div>
      </div>
      <div v-if="coachCreatedAssessment.length == 0 && loading == false">You have no active assessments</div>
    </div>
  </div>
  <create-modal @refresh="refresh" :coachAssessment="editAssessment" :display="display" @close="display=false"/>
</div>
</template>

<script>
import dataStore from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import User from "@/services/api/authUser";
import createModal from "./createModal";

export default {
  components: { createModal },
  data() {
    return {
      display: false,
      coachCreatedAssessment: [],
      editAssessment: {
        cta_img: User.image
      },
      loading: true,
      newAssessment: {
        cta_img: User.image
      },
    }
  },
  created() {
    this.refresh();
    this.setCTADefaults();
  },
  methods: {
    refresh() {
      dataStore.findAll('CoachCreatedAssessments', { limit: 200 }, { force: true }).then(r => {
        this.coachCreatedAssessment = r;
      }).finally(() => {
        this.setCTADefaults();
        this.loading = false;
      });
    },
    setCTADefaults() {
      this.newAssessment = {
        cta_img: User.user.image,
        cta_link: "https://example.com",
        cta_link_text: "Get started now!",
        cta_title: "Start a FREE digital coaching package now!"
      };
    },
    displayModal(assessment) {
      this.editAssessment = assessment;
      this.editAssessment.cta_img = User.user.image;
      this.display = true;
    },
    destroy(assessment) {
      this.coachCreatedAssessment = this.coachCreatedAssessment.filter(a => a.id !== assessment.id);
      snackbar.update("Removed");
      assessment.destroy();
    }

  }
}
</script>

<style>

</style>
